import React from 'react';

import {Fill, Stroke, Style} from 'ol/style';

import {useVectorLayer, useVectorSource} from './OpenLayers/hooks';

const LayerStyle = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
    }),
    stroke: new Stroke({
        color: 'green',
        width: 3,
    }),
});

const useSector = zIndex => {
    const source = useVectorSource({wrapX: false}, []);

    useVectorLayer({source, style: LayerStyle, zIndex}, [source]);

    return source;
};

export default useSector;
